import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "preloader d-flex align-items-center justify-content-center",
  style: {
    "width": "100%",
    "height": "20vh",
    "background-color": "white!important",
    "background-image": "none"
  }
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "block text-black-800 fs-6"
}, " Empty data ", -1);
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}